import { loadStripe } from '@stripe/stripe-js'

const stripePromise = loadStripe(
  process.env.REACT_APP_PLICKERS_STRIPE_TOKEN,
  { apiVersion: '2025-02-24.acacia' },
)

export function getStripePromise() {
  return stripePromise
}
